/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { qreq } from "../shared/qrequest";
import BaseCom from "./BaseCom";
import { EditorGlobal } from "./Editor";
import FormInput from "./FormInput";
import L from "./Lang";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class CreateSubdomain extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            query: {},
            customInfo: {}
        };
    }

    async componentDidMount() {
        await this.loadRootDomains();
    }

    async componentDidUpdate(prevProps) {
        if(this.props.show !== prevProps.show)
            await this.loadRootDomains();
    }

    loadRootDomains = async () => {
        if(EditorGlobal.siteDomain?.organizationID)
            await this.fillListAsync('/api/root-domain/list?organizationID=' + EditorGlobal.siteDomain?.organizationID, 'rootDomains');
    }

    register = async (e) => {
        e?.preventDefault();
        try {
            let j = await qreq.postAsync('/api/root-domain/register-sub', {...this.state.query, ID: EditorGlobal.siteDomainID });
            if(j.errorCode === 0) {
                this.props.onSuccess(j.item);
            }
            else
                this.alert(j.errorMessage);
        }
        catch(e) {
            this.unkownErrorCallback(e);
        }
    }

    change = () => {
        this.setState({ query: {...this.state.query} });
    }

    render() {
        const content = <div className="container-fluid">
            <form onSubmit={this.register}>
                <div className="d-flex align-items-center gap-1">
                    <FormInput model={this.state.query} name="subName" type="text" label="mysubdomain" labelAsPlaceholder required
                        onChange={this.change} />
                    <FormInput model={this.state.query} name="rootDomainID" type="select" label="Domain"
                        options={this.state.rootDomains || []} labelAsPlaceholder required optionsName="domainName"
                        onChange={this.change} />
                    <button type="submit" className="btn btn-success mb-3 rounded-0"><L>Publish</L></button>
                </div>
            </form>

        </div>;
        if (this.props.noModal)
            return content;
        else
            return this.wrapModal(content, 'Create Subdomain', 'xl');
    }
}

export default withParamsAndNavigate(CreateSubdomain);